import { render, staticRenderFns } from "./info-card.vue?vue&type=template&id=08f78bda&scoped=true"
import script from "./info-card.vue?vue&type=script&lang=js"
export * from "./info-card.vue?vue&type=script&lang=js"
import style0 from "./info-card.vue?vue&type=style&index=0&id=08f78bda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f78bda",
  null
  
)

export default component.exports